import styled from 'styled-components';
import { layout } from 'styled-system';

export const Section = styled.section.attrs({
  width: [1, '992px'],
})`
  ${layout}
  max-width: 992px;
  margin: 0 auto;
`;
